import { useAuth } from '../context/AuthContext'
import { useOrg } from '../context/OrgContext'
import { decodeHtmlEntities } from '../utils/displayText'
import { customerNavFor } from '../customerBuild'

/** The signed-in organization's name, as the pages show it. */
export function useOrgName() {
  const { org } = useOrg()
  return org?.name ? decodeHtmlEntities(org.name) : null
}

/**
 * What the Control Board's shell shows, from Rithmo's own session: the signed-in user, the current organization, and
 * the menu this role may use (members: Connections and Settings; the API refuses them the rest).
 */
export function useShellSession() {
  const { user, logout } = useAuth()
  const { isAdmin } = useOrg()
  return {
    user: user ? { name: user.name, email: user.email } : null,
    workspaceName: useOrgName(),
    items: customerNavFor(isAdmin),
    signOut: logout,
  }
}
